import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/roomPlace'

export const roomPlaceService = {
    getItem,
    saveItem,
    deleteItem,
    search,
    reorderItems,
};

//show
function getItem(idPlace) {
    return utilHelper.doRequest(`${relativeUrl}/${idPlace}`, 'GET')
}

//search
function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data:data, showAlert:false })
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//delete
function deleteItem(id,fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{});
}

function reorderItems(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/reorder`, 'POST', { data: data });
}